import React, { createContext } from "react";

const StudentsContext = createContext({
  students: [],
});

export const StudentsContextProvider = ({ children }) => {
  const students = [
  {
    id: "1239133",
    name: "Александър Иванов Иванов",
    grade: 3.06
  },
  {
    id: "1239143",
    name: "Анна Александрова Александрова",
    grade: 5.88
  },
  {
    id: "1239156",
    name: "Виктория Николаева Цочева",
    grade: 4.71
  },
  {
    id: "1239192",
    name: "Йоана Ангелова Ангелова",
    grade: 3
  },
  {
    id: "1239175",
    name: "Йоана Миткова Митева",
    grade: 5.31
  },
  {
    id: "1239218",
    name: "Калоян Калоянов Лещаков",
    grade: 3.81
  },
  {
    id: "1239234",
    name: "Калоян Миленов Миланов",
    grade: 5.01
  },
  {
    id: "1239251",
    name: "Кремена Красимирова Венциславова",
    grade: 4.77
  },
  {
    id: "1239265",
    name: "Мариела Йорданова Боярова",
    grade: 5.37
  },
  {
    id: "1239278",
    name: "Мария Асенова Александрова",
    grade: 4.05
  },
  {
    id: "1239288",
    name: "Мария Димитрова Цветкова",
    grade: 4.32
  },
  {
    id: "1239302",
    name: "Мерай Руджиханова Расимова",
    grade: 5.07
  },
  {
    id: "1239316",
    name: "Михаела Иванова Фиркова",
    grade: 5.1
  },
  {
    id: "1239364",
    name: "Моника Миленова Йорданова",
    grade: 4.68
  },
  {
    id: "1239383",
    name: "Моника Миленова Симеонова",
    grade: 5.85
  },
  {
    id: "1239401",
    name: "Нежля Саидова Ашимова",
    grade: 3.75
  },
  {
    id: "1239415",
    name: "Никола Владимиров Сомлев",
    grade: 6
  },
  {
    id: "1239424",
    name: "Славена Петкова Стойкова",
    grade: 5.1
  },
  {
    id: "1239441",
    name: "Стефания Красимирова Маринова",
    grade: 5.19
  },
  {
    id: "1239449",
    name: "Стиляна Йорданова Ангелова",
    grade: 5.85
  },
  {
    id: "1239461",
    name: "Таня Станчева Станчева",
    grade: 5.91
  },
  {
    id: "1239474",
    name: "Траян Светославов Енев",
    grade: 3.72
  },
  {
    id: "1239487",
    name: "Фетие Меляйдин Карабаджакова",
    grade: 3.18
  },
  {
    id: "1239495",
    name: "Цвета Цветомирова Дудрекова",
    grade: 5.07
  },
  {
    id: "1239501",
    name: "Ценислава Николаева Колева",
    grade: 5.52
  },
  {
    id: "1238670",
    name: "Алек Емилов Асенов",
    grade: 3.17
  },
  {
    id: "1238758",
    name: "Александър Бориславов Георгиев",
    grade: 4.53
  },
  {
    id: "1238776",
    name: "Борислав Николаев Янкулов",
    grade: 4.88
  },
  {
    id: "1238791",
    name: "Ванислав Христов Коев",
    grade: 4.68
  },
  {
    id: "1238808",
    name: "Галин Ивайлов Георгиев",
    grade: 4.5
  },
  {
    id: "1238820",
    name: "Дария Мариянова Драганова",
    grade: 4.21
  },
  {
    id: "1238831",
    name: "Десислава Бойкова Георгиева",
    grade: 6
  },
  {
    id: "1238868",
    name: "Ивана Радкова Борисова",
    grade: 5.11
  },
  {
    id: "1238847",
    name: "Иван Красимиров Витанов",
    grade: 5.64
  },
  {
    id: "1238885",
    name: "Ивона Софрониева Георгиева",
    grade: 4.22
  },
  {
    id: "1238899",
    name: "Красен Илиянов Кушев",
    grade: 3.4
  },
  {
    id: "1238913",
    name: "Кристиан Калинов Цонев",
    grade: 3.31
  },
  {
    id: "1238922",
    name: "Кристиан Стоянов Ангелов",
    grade: 3.41
  },
  {
    id: "1238951",
    name: "Кристияна Светлозарова Станчева",
    grade: 5.65
  },
  {
    id: "1238943",
    name: "Кристиян Руменов Димитров",
    grade: 5.25
  },
  {
    id: "1238966",
    name: "Мартин Красимиров Митков",
    grade: 3.15
  },
  {
    id: "1238980",
    name: "Матей Тихомиров Трендафилов",
    grade: 3.67
  },
  {
    id: "1238992",
    name: "Никол Светлозарова Димитрова",
    grade: 6
  },
  {
    id: "1239007",
    name: "Павел Пламенов Чернев",
    grade: 4.14
  },
  {
    id: "1239016",
    name: "Преслав Димитров Йорданов",
    grade: 4.01
  },
  {
    id: "1239028",
    name: "Светлана Пламенова Димитрова",
    grade: 3
  },
  {
    id: "1239042",
    name: "Симона Йорданова Йорданова",
    grade: 4.14
  },
  {
    id: "1239059",
    name: "Станислав Петков Петров",
    grade: 3.67
  },
  {
    id: "1239071",
    name: "Теодора Иванова Паленикова",
    grade: 3.35
  },
  {
    id: "1239088",
    name: "Траяна Ивайлова Иванова",
    grade: 5.75
  },
  {
    id: "1239100",
    name: "Явор Недялков Недялков",
    grade: 3
  },
  {
    id: "1239587",
    name: "Али Мехмедов Салиев",
    grade: 5.91
  },
  {
    id: "1239599",
    name: "Ачелия Метинова Джамбазова",
    grade: 6
  },
  {
    id: "1239614",
    name: "Божидар Емилов Златанов",
    grade: 3.44
  },
  {
    id: "1239643",
    name: "Божидар Станимиров Стоянов",
    grade: 3.42
  },
  {
    id: "1239653",
    name: "Веселин Бориславов Кенаров",
    grade: 6
  },
  {
    id: "1239663",
    name: "Георги Тодоров Тодоров",
    grade: 4.02
  },
  {
    id: "1239673",
    name: "Давид Тихомиров Пецуров",
    grade: 6
  },
  {
    id: "1239685",
    name: "Денис Хасан Уфук Гюлай",
    grade: 3.43
  },
  {
    id: "1239694",
    name: "Деница Димитрова Стоянова",
    grade: 3.55
  },
  {
    id: "1239704",
    name: "Димитър Йорданов Йорданов",
    grade: 4.02
  },
  {
    id: "1239711",
    name: "Ивайла Бориславова Иванова",
    grade: 4.04
  },
  {
    id: "1239722",
    name: "Ивайло Ангелов Стефанов",
    grade: 5.55
  },
  {
    id: "1239745",
    name: "Ивайло Илиев Костадинов",
    grade: 5.64
  },
  {
    id: "1239755",
    name: "Иво Боянов Иванов",
    grade: 5.2
  },
  {
    id: "1239765",
    name: "Костадин Костадинов Бояджиев",
    grade: 3.57
  },
  {
    id: "1239782",
    name: "Кристиян Тихомиров Гецов",
    grade: 3.86
  },
  {
    id: "1239788",
    name: "Максим Илиянов Кънев",
    grade: 5.52
  },
  {
    id: "1239795",
    name: "Пламенна Боянова Белчева",
    grade: 3.35
  },
  {
    id: "1239801",
    name: "Преслав Станимиров Стоянов",
    grade: 4.15
  },
  {
    id: "1239806",
    name: "Росен Николаев Николов",
    grade: 5.79
  },
  {
    id: "1239812",
    name: "Румен Стоянов Василев",
    grade: 6
  },
  {
    id: "1239817",
    name: "Теодор Петков Миланов",
    grade: 6
  },
  {
    id: "1239828",
    name: "Тони Димитров Димитров",
    grade: 4.35
  },
  {
    id: "1239834",
    name: "Христо Константинов Андреев",
    grade: 3.43
  },
  {
    id: "1239837",
    name: "Христо Христов Стефанов",
    grade: 4.15
  },
  {
    id: "1239848",
    name: "Цветомира Николаева Ангелова",
    grade: 3.9
  }
  ];
  return (
    <StudentsContext.Provider value={students}>
      {children}
    </StudentsContext.Provider>
  );
};

export default StudentsContext;
